module.exports = "/integrations/modals/modal-user-mapping-f92406.html";